<template>
  <div class="main_wrap">
    <div class="tool_bar">
      <Navigator :routeList="navigate" />
      <div class="search_bar">
        <div>共{{ total }}门课程</div>
        <el-input
          class="input search_input"
          placeholder="请输入课程名称"
          @clear="clearKeywords()"
          @keyup.enter.native="refreshList()"
          @input="keywordsChange"
          clearable
          v-model="keywordInput"
        >
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="refreshList()"
          />
        </el-input>
        <el-select
          class="input"
          v-model="grade"
          placeholder="全部年级"
          clearable
          @change="refreshList()"
          :popper-append-to-body="false"
        >
          <el-option
            v-for="item in gradeList"
            :key="item.dictCode"
            :label="item.dictLabel"
            :value="item.dictValue"
          >
          </el-option>
        </el-select>
        <el-cascader
          v-if="!ifReviewAccount"
          placeholder="请选择课程分类"
          class="input"
          v-model="type"
          :options="typeList"
          clearable
          @change="refreshList()"
          :props="{ expandTrigger: 'hover' }"
          :popper-append-to-body="false"
        ></el-cascader>
        <el-button class="search_button" type="primary" @click="refreshList()"
          >查询</el-button
        >
      </div>
    </div>
    <LoadingList class="loading_list" :listLenth="12" v-if="loadingHandle" />
    <div v-else class="main_list_wrap">
      <div class="main_list" v-if="courseList.length > 0">
        <a
          class="course_item"
          v-for="(item, index) in courseList"
          :key="index"
          href="#"
          @click.prevent="jumpTo(item)"
        >
          <div class="course_cover_wrap">
            <el-image
              class="course_cover"
              :src="getcovers(item.webSmallCoverImgUrls)"
              fit="cover"
            >
              <div class="error_img" slot="error" />
            </el-image>
          </div>
          <div class="course_info">
            <div class="course_title">
              {{ item.name }}
            </div>
            <div class="course_intro">
              <div class="course_type">
                分类：{{ item.courseTypeName || item.provinceCourseTypeName }}
              </div>
              <div class="course_grade">
                年级：{{ getGrade(item.courseGradeTermList) }}
              </div>
            </div>
          </div>
        </a>
      </div>
      <Empty v-else height="40rem" />
      <el-pagination
        background
        class="page_nav"
        layout="prev, pager, next"
        :page-size="12"
        v-if="total > 12"
        @current-change="pageChange"
        :current-page="pageNo"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { Component, Vue, Watch } from "vue-property-decorator";
import Tag from "@/components/tag";
import LoadingList from "@/components/loadingList.vue";
import Empty from "@/components/empty.vue";
import Navigator from "@/components/navigate.vue";
import { getGrade } from "@/utils/common";
import {
  getPageList,
  getPageListGuest,
  getSearchDisc,
  getProvinceType,
} from "@/api/course";
@Component({
  components: {
    Tag,
    LoadingList,
    Empty,
    Navigator,
  },
})
export default class CourseListPage extends Vue {
  courseList = [];
  keywords = "";
  keywordInput = "";
  gradeList = [];
  grade = null;
  typeList = [];
  type = [];

  pageNo = 1;
  pageSize = 12;
  total = 0;

  loadingHandle = false;
  initHandle = false;

  navigate = [
    { name: "首页", url: "/course" },
    { name: "全部课程", isCurrent: true },
  ];

  mounted() {
    this.initPage();
  }

  initPage() {
    this.loadingHandle = true;
    Promise.all([
      //获取年级：'grade'
      getSearchDisc("grade").then((data) => {
        this.gradeList = data;
        return Promise.resolve();
      }),
      //获取课程类型
      getProvinceType().then((data) => {
        //处理数据，将typeList合适的放入级联列表
        data.map((item) => {
          let obj;
          if (item.childrenType.length > 0) {
            let childrenArr = [];
            item.childrenType.map((child) => {
              let childObj = {
                value: child.type,
                label: child.typeName,
              };
              childrenArr.push(childObj);
            });
            obj = {
              value: item.type,
              label: item.typeName,
              children: childrenArr,
            };
          } else {
            obj = {
              value: item.type,
              label: item.typeName,
            };
          }
          this.typeList.push(obj);
        });
        if (this.initType) {
          if (this.initType == "ALL") {
            this.type = [];
          } else {
            this.type = this.initType;
          }
        } else this.type = [];
        return Promise.resolve();
      }),
    ]).then(() => {
      this.loadingHandle = false;
      const keywordsQuery = this.getKeywordsQuery();
      if (keywordsQuery != this.keyword && this.isNew) {
        this.keywordInput = keywordsQuery;
      }
      this.refreshList();
    });
  }
  activated() {
    if (this.initHandle && this.isNew) {
      const keywordsQuery = this.getKeywordsQuery();
      if (keywordsQuery != this.keyword) {
        this.keywordInput = keywordsQuery;
      } else this.keywordInput = "";
      if (this.initType) {
        if (this.initType == "ALL") {
          this.type = [];
        } else {
          this.type = this.initType;
        }
      } else this.type = [];
      this.refreshList();
    }
  }

  get initType() {
    let { type } = this.$route.params;
    if (type) {
      const typeArr = type.split(",");
      if (typeArr[0]) {
        //传过来的是六小类
        if (typeArr[1]) {
          type = [typeArr[0], typeArr[1]];
        }
        //传过来的是四大类
        else {
          type = [typeArr[0]];
        }
      }
      //传过来的是ALl
      else {
        type = [typeArr[1]];
      }
    } else {
      type = [];
    }

    return type;
  }

  get loginStatus() {
    return this.$store.state.AuthModule.loginStatus;
  }

  get isNew() {
    const { isNew } = this.$route.params;
    return isNew;
  }

  get ifReviewAccount() {
    return this.$store.state.UserModule.userInfo?.hasReviewAccount;
  }

  getKeywordsQuery() {
    const { keywords } = this.$route.query;
    return keywords || "";
  }

  keywordsChange() {
    if (this.keywordInput.length == 0) this.refreshList();
  }

  refreshList() {
    this.pageNo = 1;
    this.keywords = this.keywordInput;
    this.getListInfo().then(() => {
      this.initHandle = true;
    });
  }

  getGrade(grades) {
    const gradeArr = grades.map((item) => {
      return item.grade;
    });
    return getGrade(gradeArr);
  }

  jumpTo(item) {
    if (item.teachingAuxiliaryId)
      this.$router.push(
        `/course/subjectDetail/${item.id}?teachingAuxiliaryId=${item.teachingAuxiliaryId}`
      );
    else this.$router.push(`/course/detail/${item.id}`);
  }

  getcovers(covers) {
    if (covers.length > 0) return covers[0];
    else return "";
  }

  getListInfo() {
    const courseType = this.type[1];
    const provinceCourseType = this.type[0];
    const params = {
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      name: this.keywords || "",
      courseType: courseType || "",
      provinceCourseType: provinceCourseType || "",
      grade: this.grade || "",
    };
    this.loadingHandle = true;
    const fetch = this.loginStatus ? getPageList : getPageListGuest;
    return fetch(params)
      .then((data) => {
        this.courseList = data.records;
        this.total = parseInt(data.total);
      })
      .finally(() => {
        this.loadingHandle = false;
      });
  }
  clearKeywords() {
    this.keywords = "";
    this.keywordInput = "";
    this.getListInfo();
  }
  pageChange(ev) {
    this.pageNo = ev;
    this.getListInfo();
  }
  back() {
    this.$router.back();
  }
}
</script>
<style lang="scss">
.el-cascader-node {
  font-size: 1.4rem;
  height: 3.4rem;
  line-height: 3.4rem;
  padding: 0 2rem;
}
</style>
<style lang="less" scoped>
.main_wrap {
  color: #666666;
}
.tool_bar {
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem;
  border-radius: 4px;
}
.search_bar {
  display: flex;
  align-items: center;
  font-size: 1.6rem;
}
.input {
  width: 26rem;
  margin-left: 3rem;
  /deep/ .el-select-dropdown__item {
    font-size: 1.4rem;
    height: 3.4rem;
    line-height: 3.4rem;
    padding: 0 2rem;
  }
}

.search_input,
.el-select,
.el-cascader {
  /deep/ .el-input__inner {
    background: #f4f5f8;
    border: none;
  }
  /deep/ .el-input__icon {
    color: #000000;
  }
}
.search_button {
  margin-left: 2.5rem;
  background: #00A2E9;
}
.loading_list {
  margin-top: 2.5rem;
}
.main_list {
  min-height: 40rem;
  margin-top: 2.5rem;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: repeat(auto-fill, 15.6rem);
  grid-gap: 2.5rem;
  .course_item {
    text-decoration: none;
    border: solid 2px #ffffff;
    overflow: hidden;
    cursor: pointer;
    &:last-child {
      margin-right: 0;
    }
    height: 11.4rem;
    background: #ffffff;
    border-radius: 0.4rem;
    padding: 1.9rem;
    display: flex;
    user-select: none;
    .course_cover_wrap {
      width: 20.4rem;
      border-radius: 0.4rem;
      position: relative;
      overflow: hidden;
      .course_cover {
        width: 100%;
        height: 100%;
        transition: all 0.2s;
      }
    }
    .course_info {
      flex: 1;
      margin-left: 1.5rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 0.5rem 0;
      overflow: hidden;
      .course_title {
        font-size: 1.6rem;
        font-weight: bold;
        color: #000000;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .course_intro {
        color: #666666;
        font-size: 1.4rem;
        .course_type {
          margin-bottom: 1rem;
          white-space: nowrap;
        }
      }
    }
  }
  .course_item:hover,
  .course_item:active {
    border: solid 2px #00a2e9;
    box-shadow: 0 0.4rem 2rem 0 rgba(31, 31, 31, 0.1);
    .course_title {
      color: #00a2e9;
    }

    .course_cover_wrap {
      .course_cover {
        transform: scale(1.2, 1.2);
      }
    }
  }
}
.page_nav {
  display: table;
  margin: 2rem auto;
}
/deep/ .el-input__inner {
  height: 4rem;
  line-height: 4rem;
  font-size: 1.4rem;
}
/deep/ .el-input__icon {
  font-size: 1.6rem !important;
  line-height: 4rem;
}
.el-button {
  padding: 1.2rem 2rem;
  font-size: 1.4rem;
}
/deep/ .el-select-dropdown__item {
  font-size: 1.4rem;
  height: 3.4rem;
  line-height: 3.4rem;
  padding: 0 2rem;
}

/deep/ .el-pagination.is-background .btn-next,
/deep/ .el-pagination.is-background .btn-prev,
/deep/ .el-pagination.is-background .el-pager li {
  background: #ffffff;
}


</style>